<form [formGroup]="subscriptionForm" (ngSubmit)="onSubmit()">
    <mat-form-field class="w-full">
      <mat-label>Project Name</mat-label>
      <input matInput formControlName="project_name">
    </mat-form-field>
  
    <mat-form-field class="w-full">
      <mat-label>Select Domains</mat-label>
      <mat-select formControlName="domains" multiple>
        <mat-option *ngFor="let domain of ['Commercial', 'Utilities', 'Education', 'Roads']" [value]="domain">
          {{ domain }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  
    <div class="grid grid-cols-2 gap-4">
      <mat-form-field>
        <mat-label>Land Size (length or area)</mat-label>
        <input matInput type="number" formControlName="land_size">
      </mat-form-field>
  
      <mat-form-field>
        <mat-label>Built-up Area</mat-label>
        <input matInput type="number" formControlName="built_up_area">
      </mat-form-field>
  
      <mat-form-field>
        <mat-label>Unit</mat-label>
        <mat-select formControlName="built_up_unit">
          <mat-option value="Square Feet">Square Feet</mat-option>
          <mat-option value="Square Meter">Square Meter</mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-form-field>
        <mat-label>Users</mat-label>
        <input matInput type="number" formControlName="users">
      </mat-form-field>
  
      <mat-form-field>
        <mat-label>Duration (Months)</mat-label>
        <input matInput type="number" formControlName="duration">
      </mat-form-field>
    </div>
  
    <div class="text-right mt-4">
      <button mat-raised-button color="primary" type="submit">Submit</button>
    </div>
  </form>
  